"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colors = {
    orange: "#ec8800",
    rotaOrange: "#ff9300",
    rotaLightOrange: "#ffbe64",
    lightOrange: "#ffdfb2",
    lighterOrange: "#fbe9cf",
    fireOrange: "#d07902",
    black: "#000000",
    darkGrey: "#1c1b1b",
    grey: "#c7c7c7",
    lightGrey: "#dadada",
    coolGrey: "#939ba7",
    gainsboro: "#e0e0e0",
    nobel: "#a1a1a1",
    brightGrey: "#e5e9f2",
    seashellGrey: "#f0f0f0",
    smokeGrey: "#f4f4f4",
    white: "#ffffff",
    dustGrey: "#9b9b9b",
    charcoalGrey: "#4a4a4a",
    mintGreen: "#dcf1e5",
    paleYellow: "#fff8b7",
    paleIvory: "#fff2e1",
    green: "#33ad64",
    red: "#f60000",
    lightRed: "#f6afaf",
    pink: "#ff327b"
};
exports.default = colors;
